/* eslint-disable no-loop-func */
import { createListenerMiddleware } from '@reduxjs/toolkit';
import { updateUserPermissions } from 'lib/firebase';
import { updatedUserRole } from 'store/features/authentication';

export const newPortalUserDataMiddleware = createListenerMiddleware();

newPortalUserDataMiddleware.startListening({
    actionCreator: updatedUserRole,
    effect: async (action) => {
        // Account owners and power users may change roles. If you are a power user you may not change a role to account owner. Admin users with edit users privs may also change roles.
        const readOnly = action.payload.readOnly;
        updateUserPermissions(
            action.payload.currentUserId,
            action.payload.updatedUserId,
            readOnly,
            action.payload.newRoleId
        );
    },
});
